import { isUrlExternal } from '@mindtickle/utils/url';
import ExternalLink from './components/ExternalLink';
import InternalLink from './components/InternalLink';
import ReloadLink from './components/ReloadLink';

import { AdvanceLinkProps } from './type';
import { generateLink } from './utils';

const AdvanceLink = ({
  url,
  openInNewTab,
  relocate,
  onClick,
  children,
  className,
}: AdvanceLinkProps) => {
  const isExternal = isUrlExternal(url);

  if (relocate && !isExternal)
    return <ReloadLink url={url} onClick={onClick} children={children} className={className} />;
  if (isExternal || openInNewTab)
    return <ExternalLink url={url} onClick={onClick} children={children} className={className} />;

  return (
    <InternalLink
      url={generateLink(url)}
      onClick={onClick}
      children={children}
      className={className}
    />
  );
};

export default AdvanceLink;
